import axios from "axios";

axios.defaults.withCredentials = true;
axios.defaults.baseURL = `${process.env.REACT_APP_BASE_URL}`;

export const login = async (email, password) => {
  await axios.get("/sanctum/csrf-cookie");
  const res = await axios.post("/login", { email, password });
  return res.data;
};

export const logout = async () => {
  await axios.get("/api/sanctum/csrf-cookie");
  return axios.post("/api/logout");
};

export const getCurrentUser = async () => {
  await axios.get("/sanctum/csrf-cookie");
  const res = await axios.get("/api/user");
  return res.data;
};

export default axios;
